import React from "react";
import ReactDOM from "react-dom";
import "normalize.css";
import "./index.css";
import App from "./components/App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material";
import { GlobalProvider } from "./contexts/GlobalContext";
import EmbedCiTPage from "./pages/watch";

const Theme = createTheme({
    typography: {
        fontFamily: "Outfit",
    },
});

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <Switch>
                {/* ✅ This route is completely outside GlobalProvider, ThemeProvider, App */}
                <Route path="/watch" component={EmbedCiTPage} />

                {/* ✅ All other routes inside App, which includes GlobalProvider etc. */}
                <Route
                    path="/"
                    render={() => (
                        <GlobalProvider>
                            <ThemeProvider theme={Theme}>
                                <App />
                            </ThemeProvider>
                        </GlobalProvider>
                    )}
                />
            </Switch>
        </Router>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
